import React, { useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';
import BenefitCreate from './BenefitCreate';
import BenefitList from './BenefitList';
import BenefitDetail from './BenefitDetail';
import { useUser } from '../../context/UserContext';
import { useTenant } from '../../context/TenantContext';
import { useMembership } from '../../context/MembershipContext';
import {
  isTenantAdminForTenant,
  isUnitAdminForTenant,
} from '../../platform/membershipPermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import useBrowserBackStack from '../../hooks/useBrowserBackStack';

function Benefits() {
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [showCreateBenefit, setShowCreateBenefit] = useState(false);
  const [editingBenefit, setEditingBenefit] = useState(null);

  const { user } = useUser();
  const { tenantId } = useTenant();
  const { memberships } = useMembership();
  const isAdmin = isTenantAdminForTenant(memberships, tenantId, user);
  const isLocalAdmin = isUnitAdminForTenant(memberships, tenantId, user);

  const handleSelectBenefit = (benefit) => {
    setSelectedBenefit(benefit);
    setShowCreateBenefit(false);
    setEditingBenefit(null);
  };

  const resetToList = useCallback(() => {
    setSelectedBenefit(null);
    setShowCreateBenefit(false);
    setEditingBenefit(null);
  }, []);

  const onList = !selectedBenefit && !editingBenefit && !showCreateBenefit;
  const closeDetailView = useBrowserBackStack(!onList, resetToList);

  const toggleCreateBenefitForm = () => {
    if (showCreateBenefit) {
      closeDetailView();
      return;
    }
    setShowCreateBenefit(true);
    setSelectedBenefit(null);
    setEditingBenefit(null);
  };

  const handleBenefitCreated = () => {
    setShowCreateBenefit(false);
    setSelectedBenefit(null);
  };

  const handleEditBenefit = (benefit) => {
    setEditingBenefit(benefit);
    setShowCreateBenefit(false);
    setSelectedBenefit(null);
  };

  const handleBenefitUpdated = () => {
    setEditingBenefit(null);
    setSelectedBenefit(null);
  };

  const headerTitle = selectedBenefit?.title || editingBenefit?.title
    || (showCreateBenefit ? 'Nova ugodnost' : 'Ugodnosti');

  return (
    <div className="platform-module-container benefits-container">
        <ModulePageHeader
          eyebrow={!onList ? 'Ugodnosti' : undefined}
          title={headerTitle}
          subtitle={onList ? 'Članske ugodnosti in popusti.' : undefined}
          actions={(
            <>
              {!selectedBenefit && !editingBenefit && isAdmin && (
                <Button variant="primary" onClick={toggleCreateBenefitForm}>
                  {showCreateBenefit ? 'Nazaj na izbiro' : 'Ustvari ugodnost'}
                </Button>
              )}
              {(selectedBenefit || editingBenefit) && (
                <Button variant="primary" onClick={closeDetailView}>Nazaj na izbiro</Button>
              )}
            </>
          )}
        />
        {!selectedBenefit && !editingBenefit ? (
          showCreateBenefit ? (
            <BenefitCreate onBenefitCreated={handleBenefitCreated} />
          ) : (
            <BenefitList
              onSelectBenefit={handleSelectBenefit}
              isAdmin={isAdmin}
              isLocalAdmin={isLocalAdmin}
              onEditBenefit={handleEditBenefit}
            />
          )
        ) : editingBenefit ? (
          <BenefitCreate
            onBenefitCreated={handleBenefitCreated}
            benefit={editingBenefit}
            onBenefitUpdated={handleBenefitUpdated}
          />
        ) : (
          <BenefitDetail benefit={selectedBenefit} />
        )}
    </div>
  );
}

export default Benefits;
